"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _CalendarGoogle = _interopRequireDefault(require("@insided/destination/icons/CalendarGoogle"));

var _CalendarOutlook = _interopRequireDefault(require("@insided/destination/icons/CalendarOutlook"));

var _CalendarApple = _interopRequireDefault(require("@insided/destination/icons/CalendarApple"));

/**
 * Renders a calendar link item with an icon and label
 * Supports both anchor links and button actions via slots
 */
var CalendarLinkItem = function CalendarLinkItem(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      icon = _ref.icon,
      label = _ref.label;
  var className = 'event-calendar-link';

  if (onClick) {
    return (0, _preact.h)("button", {
      className: className,
      onClick: onClick
    }, icon, (0, _preact.h)("div", {
      className: "event-calendar-link-label"
    }, label));
  }

  return (0, _preact.h)("a", {
    className: className,
    href: (0, _absoluteUrlRuntime.resolveUrl)(href),
    target: "_blank",
    rel: "noreferrer"
  }, icon, (0, _preact.h)("div", {
    className: "event-calendar-link-label"
  }, label));
};

var CalendarLinks = function CalendarLinks(_ref2) {
  var appleCalendarICSDownloader = _ref2.appleCalendarICSDownloader,
      googleCalendarLink = _ref2.googleCalendarLink,
      outlookCalendarLink = _ref2.outlookCalendarLink,
      office365CalendarLink = _ref2.office365CalendarLink;
  return (0, _preact.h)("div", {
    className: "event-details-wrapper"
  }, (0, _preact.h)("div", {
    className: "event-details-container events-add-to-calendar-container"
  }, (0, _preact.h)("div", {
    className: "event-details__header_label"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.add.to.calendar",
    m: "Forum"
  })), (0, _preact.h)("div", {
    className: "event-calendar-links"
  }, (0, _preact.h)(CalendarLinkItem, {
    href: (0, _absoluteUrlRuntime.resolveUrl)(googleCalendarLink),
    icon: (0, _preact.h)(_CalendarGoogle.default, null),
    label: "Google Calendar"
  }), (0, _preact.h)(CalendarLinkItem, {
    href: (0, _absoluteUrlRuntime.resolveUrl)(outlookCalendarLink),
    icon: (0, _preact.h)(_CalendarOutlook.default, null),
    label: "Outlook Personal"
  }), (0, _preact.h)(CalendarLinkItem, {
    href: (0, _absoluteUrlRuntime.resolveUrl)(office365CalendarLink),
    icon: (0, _preact.h)(_CalendarOutlook.default, null),
    label: "Office 365"
  }), (0, _preact.h)(CalendarLinkItem, {
    onClick: appleCalendarICSDownloader,
    icon: (0, _preact.h)(_CalendarApple.default, null),
    label: "Apple Calendar"
  }))));
};

var _default = CalendarLinks;
exports.default = _default;